jQuery(function($) {

  /*
  if ( location.hash == '#price' ) {
    change_price_margin();
  }
  function change_price_margin() {
    if ( $(window).innerWidth() > 768 ) {
      $('#price').css({transition: '0s'});
      setTimeout( function() {
        $('#price').css({'padding-top': 'calc( ( 100vh - 66px ) * 0.4 )'});  
        $('#price').css({transition: '0.5s'});
      }, 50 );
    }
  }
  */
  $('#sp-r-navi li a').click(function() {
    $('#hamberger, #red-line, #sp-r-navi, #logo-red').removeClass('open');
  });

  $('a[href*="#"]').on('click',function() {
    let speed = 500;
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top;
    $('body,html').animate({scrollTop:position}, speed, 'swing');

    /*
    if ( href == '#price' || './about.html#price' ) {
      change_price_margin();
      setTimeout( function() {
        $('body,html').animate({scrollTop:position}, speed, 'swing');
      }, 300);
    } else {
      $('body,html').animate({scrollTop:position}, speed, 'swing');
    }
    */
    return false;
  });

  function show_with_delay(name, delay) {
    $(name).delay(delay).queue(function(){
      $(this).addClass('show');
    });
  }

  function on_load() {
    $('#red-line, #logo-full').addClass('show');
    show_with_delay('#hamberger', 0);
    show_with_delay('#r-navi', 500);
    show_with_delay('#about .message dd', 0);
    show_with_delay('#about .link-form', 0);
    show_with_delay('#about .info', 0);
    if ($('#page-about').length) {
      show_with_delay('#logo-red, #about', 0);
    }
  }

  const isPageTop = $('#page-top').length;
  const isPageAbout = $('#page-about').length;


  if ( isPageTop ) {
    let $fv_slider = $('ul#fv-slider').slick({
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 2000,
      fade: true,
    });
    $('#fv-slider li').imagesLoaded({background: true}, function(){
      $fv_slider.css({opacity: 1});
      on_load();
      setTimeout( function() {
        $fv_slider.slick('slickPlay');
      }, 1000);
    });
  }
  if (isPageAbout) {
    const video = document.getElementById('brand-concept-video');
    $('#btn-brand-concept-open').click(function(){
      $('.modal-brand-concept').addClass('open');
      video.play();
    })
    $('#btn-brand-concept-close').click(function(){
      $('.modal-brand-concept').removeClass('open');
      video.pause();
    })

    $('.store-slider li').imagesLoaded({background: true}, function(){
      on_load();
    });

    let $store_slider = $('ul.store-slider').slick({
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 2000,
      fade: true,
    });
    $store_slider.on('beforeChange', function(_event, _slick, _current, next){
      let current = next+1;
      $('.current-slide .current-number').text(current);
    });
  }

  $('#hamberger').click(function(){
    $('#hamberger, #red-line, #sp-r-navi, #logo-red').toggleClass('open');
  });

  if ( $('#page-about').length ) {
    function show_if_scroll( elem_name, pos, fun ) {
      if ( pos > $(elem_name).offset().top ) {
        $(elem_name).addClass('show');
      }
      if ( fun ) {
        fun();
      }
    }
    function onScroll() {
      let current = $(window).scrollTop();
      let target = $('section#footer').offset().top;
      if ( current > 10 ) {
        $('#logo-red').addClass('scrolled');
      } else {
        $('#logo-red').removeClass('scrolled');
      }
      if ( current + $(this).innerHeight() * 0.2 > target ) {
        $('#logo-red, #r-navi').addClass('white');
        $('#hamberger').addClass('hide');
      } else {
        $('#logo-red, #r-navi').removeClass('white');
        $('#hamberger').removeClass('hide');
      }
      current += $(this).innerHeight() * (3.0/4.0);
      show_if_scroll('section#store-images', current, function(){
        $('ul.store-slider').slick('slickPlay');
      });
      show_if_scroll('section#price', current, null);
      show_if_scroll('section#footer', current, function(){
        show_with_delay('#footer #logo-full', 800);
        show_with_delay('#footer #sp-r-navi-footer', 1400);
      });
    }
    $(window).scroll(onScroll);
    onScroll();
  }

  const naviLinks = [...document.querySelectorAll('#r-navi a'), ...document.querySelectorAll('#sp-r-navi a')];
  naviLinks.forEach(link => {
    link.addEventListener('click', e => {
      const href = link.getAttribute('href');
      const nextIsAbout = href.startsWith('./about.html');
      const nextIsTop = href.startsWith('./index.html');
      const isExternal = link.getAttribute('target') === '_blank';
      const isAnchor = href.startsWith('#');
      if ( isExternal || isAnchor ) {
        return
      }
      e.preventDefault();
      if ( isPageTop && nextIsAbout ) {
        requestAnimationFrame(() => {
          if ( isPageTop && nextIsAbout ) {
            $('#logo-red').removeClass('white');
            $('#logo-red').addClass('about');
            $('#logo-full').removeClass('show');
            $('#fv-slider').css({opacity: 0});
            if ( window.innerWidth > 768 ) {
              $('#r-navi').removeClass('white');
              $('#r-navi').removeClass('top');
            }
          }
        });
      }
      if ( isPageAbout && nextIsTop ) {
        requestAnimationFrame(() => {
          $('main').removeClass('show');
          $('#red-line').addClass('to-bottom');
          $('#logo-red').addClass('slow-transition');
          $('#r-navi').addClass('white');
          $('#r-navi').addClass('top');
          setTimeout(()=>{
            requestAnimationFrame(() => {
              $('#red-line').removeClass('show');
              $('#logo-red').addClass('white');
            })
          }, 16)
        })
      }
      setTimeout( function() {
        window.location.href = href;
      }, 500)
    });
  })
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      window.location.reload();
    }
  })



});
